import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "chakra-react-select";
import { customComponents } from "./MenuPortal";
export const MatchColumnSelect = ({ onChange, value, options, placeholder, name, }) => {
    return (_jsx(Select, { value: value || null, colorScheme: "gray", useBasicStyles: true, onChange: onChange, placeholder: placeholder, options: options, menuPosition: "fixed", components: customComponents, "aria-label": name }));
};
